/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EditPaymentMethodAppEnablementForLocationDto,
  EnsurePaymentMethodForLocationRequest,
  ErrorMessage,
  LocationPaymentMethodDto,
  PaymentProvider,
} from '../models/index';
import {
    EditPaymentMethodAppEnablementForLocationDtoFromJSON,
    EditPaymentMethodAppEnablementForLocationDtoToJSON,
    EnsurePaymentMethodForLocationRequestFromJSON,
    EnsurePaymentMethodForLocationRequestToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    LocationPaymentMethodDtoFromJSON,
    LocationPaymentMethodDtoToJSON,
    PaymentProviderFromJSON,
    PaymentProviderToJSON,
} from '../models/index';

export interface EditPaymentMethodAppEnablementForLocationRequest {
    locationId: number;
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    editPaymentMethodAppEnablementForLocationDto: EditPaymentMethodAppEnablementForLocationDto;
}

export interface EnsurePaymentMethodForLocationOperationRequest {
    locationId: number;
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    ensurePaymentMethodForLocationRequest: EnsurePaymentMethodForLocationRequest;
}

export interface GetPaymentMethodsForLocationRequest {
    locationId: number;
}

/**
 * 
 */
export class LocationPaymentMethodControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for editPaymentMethodAppEnablementForLocation without sending the request
     */
    async editPaymentMethodAppEnablementForLocationRequestOpts(requestParameters: EditPaymentMethodAppEnablementForLocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling editPaymentMethodAppEnablementForLocation().'
            );
        }

        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling editPaymentMethodAppEnablementForLocation().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling editPaymentMethodAppEnablementForLocation().'
            );
        }

        if (requestParameters['editPaymentMethodAppEnablementForLocationDto'] == null) {
            throw new runtime.RequiredError(
                'editPaymentMethodAppEnablementForLocationDto',
                'Required parameter "editPaymentMethodAppEnablementForLocationDto" was null or undefined when calling editPaymentMethodAppEnablementForLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/locations/{locationId}/payment-methods/{paymentProvider}/{paymentMethod}`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EditPaymentMethodAppEnablementForLocationDtoToJSON(requestParameters['editPaymentMethodAppEnablementForLocationDto']),
        };
    }

    /**
     */
    async editPaymentMethodAppEnablementForLocationRaw(requestParameters: EditPaymentMethodAppEnablementForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.editPaymentMethodAppEnablementForLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async editPaymentMethodAppEnablementForLocation(requestParameters: EditPaymentMethodAppEnablementForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.editPaymentMethodAppEnablementForLocationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for ensurePaymentMethodForLocation without sending the request
     */
    async ensurePaymentMethodForLocationRequestOpts(requestParameters: EnsurePaymentMethodForLocationOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling ensurePaymentMethodForLocation().'
            );
        }

        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling ensurePaymentMethodForLocation().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling ensurePaymentMethodForLocation().'
            );
        }

        if (requestParameters['ensurePaymentMethodForLocationRequest'] == null) {
            throw new runtime.RequiredError(
                'ensurePaymentMethodForLocationRequest',
                'Required parameter "ensurePaymentMethodForLocationRequest" was null or undefined when calling ensurePaymentMethodForLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/locations/{locationId}/payment-methods/{paymentProvider}/{paymentMethod}`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace(`{${"paymentProvider"}}`, encodeURIComponent(String(requestParameters['paymentProvider'])));
        urlPath = urlPath.replace(`{${"paymentMethod"}}`, encodeURIComponent(String(requestParameters['paymentMethod'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EnsurePaymentMethodForLocationRequestToJSON(requestParameters['ensurePaymentMethodForLocationRequest']),
        };
    }

    /**
     */
    async ensurePaymentMethodForLocationRaw(requestParameters: EnsurePaymentMethodForLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.ensurePaymentMethodForLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async ensurePaymentMethodForLocation(requestParameters: EnsurePaymentMethodForLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.ensurePaymentMethodForLocationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getPaymentMethodsForLocation without sending the request
     */
    async getPaymentMethodsForLocationRequestOpts(requestParameters: GetPaymentMethodsForLocationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getPaymentMethodsForLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/locations/{locationId}/payment-methods`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentMethodsForLocationRaw(requestParameters: GetPaymentMethodsForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LocationPaymentMethodDto>>> {
        const requestOptions = await this.getPaymentMethodsForLocationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LocationPaymentMethodDtoFromJSON));
    }

    /**
     */
    async getPaymentMethodsForLocation(requestParameters: GetPaymentMethodsForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LocationPaymentMethodDto>> {
        const response = await this.getPaymentMethodsForLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
